import axios from 'axios';
import { API } from '../config';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';

const path = "/varas-infancia"

class VaraService {
  getVaras() {
    return axios.get(API + path)
  }

  pesquisarVaras(filters) {
    const { nome, comarca, comarcas } = filters;

    return axios.get(API + path + "/pesquisar", {
      params: {
        nome: nome !== "" ? nome : undefined,
        comarca: comarca !== "" ? comarca : undefined,
        comarcas: comarcas !== "" ? comarcas : undefined
      },
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, v));
          } else if (value !== undefined && value !== null) {
            searchParams.append(key, value);
          }
        });
        return searchParams.toString();
      },
    });
  }
}

const instanceVara = new VaraService();
export default instanceVara;
